export default __webpack_public_path__ + "static/media/womens-apparel.e9a02611.png";